import React, { useCallback, useEffect, useRef } from 'react'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledAlert,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Input,
  ModalFooter,
} from "reactstrap"
import Dropdown from 'react-bootstrap/Dropdown';
import { Table } from "react-bootstrap"
import { ERROR_KEY, SUCCESS_KEY, allValidFileTypes, fieldLengths } from '../../../Constants/MainKeys'
import { addButtonSpinner, addRightSectionSpinner, removeButtonSpinner, removeRightSectionSpinner } from '../../../store/spinner/actions'
import AlertService from '../../../Services/alertService'
import { useDispatch, useSelector } from 'react-redux'
import HtmlHead from '../../../components/HtmlHead/HtmlHead'
import RightSectionSpinner from '../../../components/Spinners/RightSectionSpinner'
import uuid from 'react-uuid'
import { useState } from 'react'
import NoData from '../../../components/NoData/NoData'
import MainService from '../../../Services/MainService'
import ActionButton from '../../../components/Buttons/ActionButton'
import LevelOneRequirementsForm from './components/LevelOneRequirementsForm'
import LevelOneRequirements from './components/LevelOneRequirements'
import LevelTwoRequirementsForm from './components/LevelTwoRequirementsForm'
import LevelTwoRequirements from './components/LevelTwoRequirements'
import Auxiliary from '../../../hoc/auxiliary/auxiliary'
import LevelThreeRequirements from './components/LevelThreeRequirements'
import LevelThreeRequirementsForm from './components/LevelThreeRequirementsForm'
import ApiService from '../../../Services/ApiService';
import OverlayTriggerComponent from '../../../components/OverlayTriggerComponent/OverlayTriggerComponent';
import { useWindowSize } from '../../../components/Hooks/useWindowSize';
import { Link } from 'react-router-dom';
import { setRoutingTypes } from '../../../store/main/actions';

function useOutsideAlerter(ref, cb) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        cb(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

const buttonSpinnerId = uuid();

const OrganizationKYC = (props) => {

  const { organizationId } = props.match.params;
  const { routingTypes, countries } = useSelector(state => state.Main);
  const dispatch = useDispatch();
  const title = "Merchant KYC";
  const description = "";
  const windowSize = useWindowSize();
  const { buttonSpinners } = useSelector(state => state.Spinners);
  const { rightSectionSpinners } = useSelector(state => state.Spinners);
  const { language } = useSelector(state => state.Languages);
  const { user } = useSelector(state => state.Login);
  const mainService = new MainService();
  const wrapperRef = useRef(null);
  const [zoomImagePath, setZoomImagePath] = useState(null);
  useOutsideAlerter(wrapperRef, setZoomImagePath);
  const [isForm, setIsForm] = useState(false);
  const [isInvalidSubmit, setIsInvalidSubmit] = useState(false);
  const [customActiveTab, setCustomIconActiveTab] = useState(localStorage.getItem("activeTab") || "1");
  const [organizationData, setOrganizationData] = useState(null);
  const [_organizationData, _setOrganizationData] = useState(null);
  const [isDisabledFields, setIsDisabledFields] = useState(false);
  const [kycLevels, setKycLevels] = useState([]);
  const [confirmLoaderId, setConfirmLoaderId] = useState(null);
  const [isShowRejectModal, setIsShowRejectModal] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");
  const [currencies, setCurrencies] = useState([]);
  const [payoutMethods, setPayoutMethods] = useState([]);
  const [holderTypes, setHolderTypes] = useState([]);
  const [banks, setBanks] = useState([]);
  const [selectedBankAccount, setSelectedBankAccount] = useState(null);
  const [_routingTypes, _setRoutingTypes] = useState([]);

  useEffect(() => {
    getOrganizationById(organizationId)
  }, [organizationId])

  useEffect(() => {
    getKycLevels();
  }, [])


  useEffect(() => {
    if (selectedBankAccount && Object.keys(selectedBankAccount).length) {
      const { country, label, currency, value, ...rest } = selectedBankAccount;
      setOrganizationData((values) => ({
        ...values,
        levelThree: {
          ...values?.levelThree,
          ...rest,
        },
      }));
    }
  }, [selectedBankAccount]);

  useEffect(() => {
    let isMounted = true;
    if (!banks?.length) {
      if (isMounted) setSelectedBankAccount(null);
      return;
    }

    const foundBank = banks.find(
      (el) => el.bankName === organizationData?.levelThree?.bankName
    ) || null;

    if (isMounted) setSelectedBankAccount(foundBank);

    return () => {
      isMounted = false; // cleanup
    };
  }, [organizationData?.levelThree?.bankName, banks]);



  useEffect(() => {
    if (organizationData) {
      let kycData = [...kycLevels];
      if (organizationData && !organizationData.levelOne) {
        kycData = kycData.filter(item => item.key !== 1)
      }
      if (!organizationData.levelTwo) {
        kycData = kycData.filter(item => item.key !== 2)
      }
      if (!organizationData.levelThree) {
        kycData = kycData.filter(item => item.key !== 3)
      }
      setKycLevels(kycData)
    }
  }, [organizationData])

  useEffect(() => {
    getBankList();
  }, [organizationData?.levelThree?.currencyId, organizationData?.levelThree?.countryId, currencies, countries])

  const getRoutingTypesLibrary = () => {
    const spinnerId = uuid();
    setRightSectionSpinner(spinnerId);
    ApiService.getRoutingTypesLibrary().then(response => {
      if (response) {
        dispatch(setRoutingTypes(response))
      }
    }).catch(error => getFail(error)).finally(() => {
      extractRightSectionSpinner(spinnerId)
    })
  }










  // for Pyvio
  // Pyvio-i kyc-i hamara 11.11.2025-in em avelacrel
  const fieldMap = {
    accountName: "account_name",
    accountNumber: "account_no",
    bankName: "bank_name",
    bankCode: "bank_code",
    branchCode: "branch_code",
    bankAddress: "bank_address",
    swiftCode: "swift_code",
    province: "province",
    city: "city",
    iBan: "iban",
    routingValue: "routing_value1",
    routingTypeLibraryDataId: "routing_type1",
  };
  const [validationData, setValidationData] = useState(null);

  useEffect(() => {
    if (holderTypes.length && countries.length && currencies.length && payoutMethods.length) {
      getPayeeTemplate();
    }
  }, [
    organizationData?.levelThree?.holderTypeLibraryDataId,
    organizationData?.levelThree?.currencyId,
    organizationData?.levelThree?.countryId,
    organizationData?.levelThree?.paymentMethodLibraryDataId,
    organizationData?.levelThree?.routingTypeLibraryDataId,
    holderTypes,
    countries,
    currencies,
    payoutMethods
  ])

  const getPayeeTemplate = () => {
    // const data = {
    //   payeeType: "Payee",
    //   holderType: "Company",
    //   country: "HK",
    //   currency: "USD",
    //   paymentMethod: "Swift",
    //   routingType: "Swift"
    // }
    const data = {
      payeeType: "Payee",
    }
    if (holderTypes.length && organizationData?.levelThree?.holderTypeLibraryDataId) {
      data.holderType = holderTypes.find(el => el.id === organizationData?.levelThree?.holderTypeLibraryDataId)?.displayName;
    }
    if (countries.length && organizationData?.levelThree?.countryId) {
      data.country = countries.find(el => el.id === organizationData?.levelThree?.countryId)?.isoCode2;
    }
    if (currencies.length && organizationData?.levelThree?.currencyId) {
      data.currency = currencies.find(el => el.id === organizationData?.levelThree?.currencyId)?.name;
    }
    if (payoutMethods && payoutMethods.length) {
      data.paymentMethod = payoutMethods.find(el => el.id === organizationData?.levelThree?.paymentMethodLibraryDataId)?.displayName;
    }
    if (organizationData.levelThree?.routingTypeName) {
      data.routingType = organizationData.levelThree?.routingTypeName;
    }
    const spinnerId = uuid();
    setRightSectionSpinner(spinnerId);
    ApiService.getPayeeTemplate(data).then(response => {
      if (response && response.data && response.data.data) {
        const backendData = JSON.parse(response.data.data);
        if (backendData && backendData.data && backendData.data.length) {
          const validationSchema = {
            ...backendData.data[0]?.bank_account_info,
            // ...backendData.data[0]?.payee_info
          };
          setValidationData(validationSchema);
        } else {
          setValidationData(null);
        }
      } else {
        setValidationData(null);
      }
    }).catch(error => getFail(error)).finally(() => {
      extractRightSectionSpinner(spinnerId);
    })
  }
  const isInvalid = (obj, fieldName) => {
    if (!validationData || !fieldMap[fieldName]) return false;

    const backendKey = fieldMap[fieldName];
    const schema = validationData;
    const rule = schema[backendKey];
    if (!rule) return false;

    const value = organizationData[obj][fieldName] || "";
    if (rule.required && !value.trim()) return true;
    if (rule.type === "OPTION") {
      rule.pattern = "^[0-9]+$";
    }
    if (rule.pattern && value) {
      try {
        return !new RegExp(rule.pattern).test(value);
      } catch (e) {
        console.warn("Invalid regex pattern:", rule.pattern);
        return false;
      }
    }

    return false;
  };

  const isFormValid = () => {
    if (!validationData) return true;
    return Object.keys(fieldMap).every(fieldName => !isInvalid("levelThree", fieldName));
  };

  useEffect(() => {
    if (routingTypes && routingTypes.libraryData && routingTypes.libraryData.length && organizationData?.levelThree?.routingTypeName) {
      setOrganizationData(values => ({
        ...values,
        levelThree: {
          ...values?.levelThree,
          routingTypeLibraryDataId:
            routingTypes.libraryData.find(el => el.displayName === organizationData?.levelThree?.routingTypeName)?.id || 0,
        }
      }));
    }
  }, [routingTypes, organizationData?.levelThree?.routingTypeName])

  useEffect(() => {
    getRoutingTypes();
  }, [
    organizationData?.levelThree?.countryId,
    organizationData?.levelThree?.currencyId,
    organizationData?.levelThree?.paymentMethodLibraryDataId,
    organizationData?.levelThree?.holderTypeLibraryDataId,
    holderTypes,
    countries,
    currencies,
    payoutMethods
  ])

  const getRoutingTypes = () => {
    if (
      !holderTypes.length ||
      !countries.length ||
      !currencies.length ||
      !payoutMethods.length ||
      !organizationData?.levelThree?.countryId ||
      !organizationData?.levelThree?.currencyId ||
      !organizationData?.levelThree?.paymentMethodLibraryDataId ||
      !organizationData?.levelThree?.holderTypeLibraryDataId
    ) {
      _setRoutingTypes([]);
      setOrganizationData((values) => ({
        ...values,
        levelThree: {
          ...values?.levelThree,
          routingTypeName: null,
        },
      }));
      return false;
    }
    // const data = {
    //   country: "",
    //   currency: "",
    //   paymentMethod: "",
    //   holderType: "",
    // }
    if (!organizationData?.levelThree?.countryId || !organizationData?.levelThree?.currencyId || !organizationData?.levelThree?.paymentMethodLibraryDataId || !organizationData?.levelThree?.holderTypeLibraryDataId) { return false; }
    const data = {};
    if (holderTypes.length && organizationData?.levelThree?.holderTypeLibraryDataId) {
      data.holderType = holderTypes.find(el => el.id === organizationData?.levelThree?.holderTypeLibraryDataId)?.displayName;
    }
    if (countries.length && organizationData?.levelThree?.countryId) {
      data.country = countries.find(el => el.id === organizationData?.levelThree?.countryId)?.isoCode2;
    }
    if (currencies.length && organizationData?.levelThree?.currencyId) {
      data.currency = currencies.find(el => el.id === organizationData?.levelThree?.currencyId)?.name;
    }
    if (payoutMethods && payoutMethods.length) {
      data.paymentMethod = payoutMethods.find(el => el.id === organizationData?.levelThree?.paymentMethodLibraryDataId)?.displayName;
    }
    const spinnerId = uuid();
    setRightSectionSpinner(spinnerId);
    ApiService.getRoutingTypes(data).then(response => {
      if (response && response.data && response.data.length) {
        _setRoutingTypes(response.data);
      } else {
        _setRoutingTypes([]);
      }
    }).catch(error => getFail(error)).finally(() => {
      extractRightSectionSpinner(spinnerId);
    })
  }

  //













  const getBankList = () => {
    if (!organizationData || (organizationData && !organizationData.levelThree)) {
      setBanks([]);
      return false;
    }
    if (organizationData && organizationData.levelThree && (!organizationData.levelThree.countryId || !organizationData.levelThree.currencyId)) {
      setBanks([]);
      return false;
    }
    if (!organizationData.levelThree?.countryId || !organizationData.levelThree?.currencyId || !countries.length || !currencies.length) { return false; }
    const data = {
      country: countries.find(el => el.id === organizationData.levelThree?.countryId)?.isoCode2,
      currency: currencies.find(el => el.id === organizationData.levelThree?.currencyId)?.name,
      page_no: "0",
      page_size: "500"
    }
    ApiService.getBankList(data).then(response => {
      if (response && response.data && response.data.list) {
        setBanks(response.data.list);
      } else {
        setBanks([]);
      }
    }).catch(error => getFail(error)).finally(() => { })
  }

  const getKycLevels = () => {
    const spinnerId = uuid();
    setRightSectionSpinner(spinnerId)
    ApiService.getKycLevels().then(response => {
      if (response && response.data) {
        setKycLevels(response.data)
      }
    }).catch(error => getFail(error)).finally(() => {
      extractRightSectionSpinner(spinnerId)
    })
  }

  const _onChange = (event, cb, maxLength = Infinity) => {
    if (maxLength && maxLength < event.target.value.length) { return; }
    cb(event.target.value)
    setIsInvalidSubmit(false);
  }

  const getOrganizationById = (organizationId) => {
    if (!organizationId) { return false; }
    const spinnerId = uuid();
    setRightSectionSpinner(spinnerId);
    ApiService.getOrganizationById(organizationId).then(response => {
      if (response && response.data) {
        let data = { ...response.data }
        if (response.data.levelTwo && data.levelTwo.files && data.levelTwo.files.length) {
          const groupedFiles = data.levelTwo.files.reduce((groups, file) => {
            const key = file.fileType;
            (groups[key] = groups[key] || []).push(file);
            return groups;
          }, {});
          const arrayOfArrays = Object.values(groupedFiles);
          if (arrayOfArrays && arrayOfArrays.length) {
            arrayOfArrays.forEach(item => {
              data.levelTwo[MainService.getOrganizationDetailsFileNameByType(item[0].fileType)] = item;
            })
          }
        }
        if (data.levelOne.userFiles && data.levelOne.userFiles.length) {
          data.levelOne.userFiles.forEach(item => {
            data.levelOne[MainService.getUserFileNameByType(item.fileType)] = item;
          })
        }
        setOrganizationData(data);
        _setOrganizationData(data);

      }
    }).catch(error => getFail(error)).finally(() => {
      setTimeout(() => {
        extractRightSectionSpinner(spinnerId);
      }, 1000);
    })
  }

  const onChange = (event, obj, fieldName, maxLength = Infinity) => {
    if (maxLength && maxLength < event.target.value.length) { return; }
    setOrganizationData((values) => ({
      ...values,
      [obj]: {
        ...values[obj],
        [fieldName]: event.target.value,
      }
    }));
    setIsInvalidSubmit(false);
  }

  const onBankSelectOptionChange = (value, obj) => {
    setOrganizationData((values) => ({
      ...values,
      [obj]: {
        ...values[obj],
        bankName: value.bankName,
        bankCode: value.bankCode,
        swiftCode: value.swiftCode,
      }
    }));
  }

  const onSelectOptionChange = (value, obj, fieldName) => {
    if (fieldName === "countryId") {
      setOrganizationData((values) => ({
        ...values,
        [obj]: {
          ...values[obj],
          paymentMethodLibraryDataId: null,
          holderTypeLibraryDataId: null,
          currencyId: null,
          routingTypeLibraryDataId: null,
          routingTypeName: null,
        }
      }));
      setPayoutMethods([]);
      setHolderTypes([]);
      setCurrencies([]);
    } else if (fieldName === "paymentMethodLibraryDataId") {
      setOrganizationData((values) => ({
        ...values,
        [obj]: {
          ...values[obj],
          holderTypeLibraryDataId: null,
          currencyId: null,
          routingTypeLibraryDataId: null,
          routingTypeName: null,
        }
      }));
      setHolderTypes([]);
      setCurrencies([]);
    } else if (fieldName === "holderTypeLibraryDataId") {
      setOrganizationData((values) => ({
        ...values,
        [obj]: {
          ...values[obj],
          routingTypeLibraryDataId: null,
          routingTypeName: null,
        }
      }));
    } else if (fieldName === "currencyId") {
      setOrganizationData((values) => ({
        ...values,
        [obj]: {
          ...values[obj],
          routingTypeLibraryDataId: null,
          routingTypeName: null,
        }
      }));
    }
    setOrganizationData((values) => ({
      ...values,
      [obj]: {
        ...values[obj],
        [fieldName]: value,
      }
    }));
  }

  useEffect(() => {
    if (organizationData && organizationData.levelThree) {
      if (organizationData?.levelThree?.countryId) {
        getPaymentMethodsByCountryId(organizationData?.levelThree?.countryId);
      }
    }
  }, [organizationData && organizationData?.levelThree && organizationData?.levelThree?.countryId])

  const getPaymentMethodsByCountryId = (countryId) => {
    if (!countryId) { return false; }
    ApiService.getPaymentMethodsByCountryId(countryId).then(response => {
      if (response && response.data) {
        setPayoutMethods(response.data)
      } else {
        setPayoutMethods([]);
      }
    }).catch(error => getFail(error)).finally(() => { })
  }

  const getHolderTypesByCountry = (countryId, paymentMethodId) => {
    if (!countryId) { return false; }
    ApiService.getHolderTypesByCountry(countryId, paymentMethodId).then(response => {
      if (response && response.data) {
        setHolderTypes(response.data)
      } else {
        setHolderTypes([]);
      }
    }).catch(error => getFail(error)).finally(() => { })
  }

  useEffect(() => {
    if (organizationData && organizationData.levelThree) {
      if (organizationData?.levelThree?.countryId && organizationData.levelThree.paymentMethodLibraryDataId) {
        getHolderTypesByCountry(organizationData?.levelThree?.countryId, organizationData.levelThree.paymentMethodLibraryDataId);
        getFiatCurrencies(organizationData?.levelThree?.countryId, organizationData.levelThree.paymentMethodLibraryDataId);
      }
    }

  }, [organizationData && organizationData?.levelThree && organizationData?.levelThree?.countryId, organizationData && organizationData?.levelThree && organizationData.levelThree.paymentMethodLibraryDataId])

  const getFiatCurrencies = (countryId, paymentMethodId) => {
    if (!countryId || !paymentMethodId) { return false; }
    ApiService.getFiatCurrenciesByCountryIdAndPaymentMethodId(countryId, paymentMethodId).then(response => {
      if (response && response.data) {
        setCurrencies(response.data);
      } else {
        setCurrencies([]);
      }
    }).catch(error => getFail(error)).finally(() => { })
  }

  const onSwitcherChange = (bool, obj, fieldName) => {
    AlertService.alertConfirm(
      `Are you sure ?`,
      "You want to update organization detail liveness test status.",
      "Yes",
      "No"
    ).then(() => {
      let data = {
        id: +organizationData[obj]?.id || null,
        updaterUserId: null,
        status: bool,
      }
      setIsDisabledFields(true);
      ApiService.updateOrganizationDetailLivenessTestStatus(data).then(response => {
        setOrganizationData((values) => ({
          ...values,
          [obj]: {
            ...values[obj],
            [fieldName]: bool,
          }
        }));
        AlertService.alert(SUCCESS_KEY, "Organization detail liveness test status updated successfully")
      }).catch(error => getFail(error)).finally(() => {
        setIsDisabledFields(false);
      })
    })
  }

  const onStatusSwitcherChange = (bool, obj, fieldName) => {
    AlertService.alertConfirm(
      `Are you sure ?`,
      `You want to ${bool ? "approve" : "reject"} bank account.`,
      "Yes",
      "No"
    ).then(() => {
      let data = {
        id: +organizationData[obj]?.id || null,
        updaterUserId: null,
        status: bool,
        entityType: 1,
      }
      setIsDisabledFields(true);
      ApiService.updateBankAccountStatusAsAdmin(data).then(response => {
        setOrganizationData((values) => ({
          ...values,
          [obj]: {
            ...values[obj],
            [fieldName]: bool,
          }
        }));
        _setOrganizationData((values) => ({
          ...values,
          [obj]: {
            ...values[obj],
            [fieldName]: bool,
          }
        }));
        AlertService.alert(SUCCESS_KEY, "Bank account status updated successfully")
      }).catch(error => getFail(error)).finally(() => {
        setIsDisabledFields(false);
      })
    })
  }

  const uploadFile = async (data) => {
    const { event, obj, fieldName, checkFiltType, method, id } = data;
    if (!event.target.files.length) { return false; }
    const formData = new FormData();

    let files = [...event.target.files];
    let file = files[0];
    const fileName = file.name;
    const lastDotIndex = fileName.lastIndexOf('.');
    const fileExtention = lastDotIndex !== -1 ? fileName.substring(lastDotIndex + 1).toLowerCase() : ' ';
    if (allValidFileTypes.includes(fileExtention.toLowerCase())) {
      formData.append("id", id);
      formData.append("document", file);
      formData.append("type", checkFiltType(fieldName));
      method(formData).then(response => {
        setOrganizationData((values) => ({
          ...values,
          [obj]: {
            ...values[obj],
            [fieldName]: response.data,
          }
        }));
        AlertService.alert(SUCCESS_KEY, "Data saved")
      }).catch(error => getFail(error))
    } else {
      AlertService.alert("error", "Invalid file format")
      return false;
    }
  };

  const bulkUploadFile = async (data) => {
    const { event, fieldName, checkFiltType, method, obj, id } = data;
    if (!event.target.files.length) { return false; }
    const formData = new FormData();
    formData.append("id", id);
    formData.append("type", checkFiltType(fieldName));
    let files = [...event.target.files];
    for (let i in files) {
      let file = files[i];
      let fileName = file.name;
      let lastDotIndex = fileName.lastIndexOf('.');
      let fileExtention = lastDotIndex !== -1 ? fileName.substring(lastDotIndex + 1).toLowerCase() : ' ';

      if (allValidFileTypes.includes(fileExtention.toLowerCase())) {
        await mainService.readFile(file, allValidFileTypes).then(uploadedFile => {
          formData.append("documents", file);
        }).catch(error => {
          error && AlertService.alert("error", "Invalid file format");
        });
      } else {
        AlertService.alert("error", "Invalid file format")
        return false;
      }
    }
    method(formData).then(response => {
      let _organizationData = { ...organizationData };
      _organizationData[obj][fieldName] = [..._organizationData[obj][fieldName] || [], ...response.data];
      setOrganizationData(_organizationData)
      AlertService.alert(SUCCESS_KEY, "Data saved")
    }).catch(error => getFail(error))
  };

  const deleteDocument = (data) => {
    const { fieldName, fileObj, fileLibraryId, getFileType, method, id } = data;
    if (!fileLibraryId || !getFileType) { return false; }
    AlertService.alertConfirm(
      `Are you sure you want to delete current file ?`,
      "",
      "Yes",
      "No"
    ).then(() => {
      (method ? method(fileLibraryId, id, getFileType(fieldName)) :
        ApiService.deleteDocumentAsAdmin(fileLibraryId, id, getFileType(fieldName))).then(() => {
          if (Array.isArray(organizationData[fileObj][fieldName])) {
            setOrganizationData((values) => ({
              ...values,
              [fileObj]: {
                ...values[fileObj],
                [fieldName]: organizationData[fileObj][fieldName].filter(item => item.fileLibraryId !== fileLibraryId),
              }
            }));
          } else {
            setOrganizationData((values) => ({
              ...values,
              [fileObj]: {
                ...values[fileObj],
                [fieldName]: null,
              }
            }));
          }
          AlertService.alert(SUCCESS_KEY, "File deleted successfully")
        }).catch(error => getFail(error))
    })
  }

  // approveOrganizationKYCDocument

  const confirmProof = (data, type = 1) => {
    const { fileObj, fieldName } = data;

    let entityId = organizationData?.levelTwo?.id;
    let fileLibraryId = organizationData[fileObj][fieldName].fileLibraryId || null;
    if (confirmLoaderId === fileLibraryId) {
      return false;
    }
    AlertService.alertConfirm(
      `Are you sure?`,
      "Confirming the document makes it legal for Cryllex and partner agents.",
      "Yes",
      "No"
    ).then(() => {
      setConfirmLoaderId(fileLibraryId);
      let _data = { entityId: entityId, fileLibraryId: fileLibraryId, bankAccountEntityType: 1 };
      (type === 1 ? ApiService.approveOrganizationKYCDocument(_data) : ApiService.approveBankAccountDocument(_data)).then(response => {
        let _obj = organizationData[fileObj][fieldName];
        _obj.isActive = response.data || false;
        setOrganizationData((values) => ({
          ...values,
          [fileObj]: {
            ...values[fileObj],
            [fieldName]: _obj,
          }
        }));
        AlertService.alert(SUCCESS_KEY, "File confirmed successfully")
      }).catch(error => getFail(error)).finally(() => {
        setConfirmLoaderId(null);
      })
    })
  }

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  const onChangeKycLevel = (item, fieldName) => {
    if (!item) { return false; }
    AlertService.alertConfirm(
      `Are you sure`,
      "You want to change KYC level ?",
      "Yes",
      "No"
    ).then(() => {
      setIsDisabledFields(true);
      const data = {
        id: organizationData.id,
        updaterUserId: null,
        kycLevel: item
      }
      ApiService.updateOrganizationKycLevel(data).then(() => {
        setOrganizationData((values) => ({
          ...values,
          [fieldName]: item
        }))
        AlertService.alert(SUCCESS_KEY, "Organization KYC level updated successfully")
      }).catch(error => getFail(error)).finally(() => {
        setIsDisabledFields(false)
      })
    })
  }


  const accept = (spinnerId) => {
    AlertService.alertConfirm(
      `Are you sure ?`,
      "",
      "Yes",
      "No"
    ).then(() => {
      setButtonSpinner(spinnerId);
      const data = {
        id: organizationData.id,
        updaterUserId: null,
        status: true
      }
      ApiService.updateOrganizationStatus(data).then(response => {
        AlertService.alert(SUCCESS_KEY, "Data saved");
        setOrganizationData((values) => ({
          ...values,
          isApproved: true,
          isRejected: false,
          isPending: true,
        }))
      }).catch(error => getFail(error)).finally(() => {
        extractButtonSpinner(spinnerId)
      })
    })
  }

  const reject = (spinnerId) => {
    if (!rejectMessage.trim().length) {
      setIsInvalidSubmit(true);
      return false;
    }
    setButtonSpinner(spinnerId);
    const data = {
      id: organizationData.id,
      updaterUserId: null,
      status: false,
      rejectMessage,
    }
    ApiService.updateOrganizationStatus(data).then(response => {
      AlertService.alert(SUCCESS_KEY, "Data saved");
      setOrganizationData((values) => ({
        ...values,
        isApproved: false,
        isRejected: true,
        isPending: false,
      }))
      setRejectMessage("");
    }).catch(error => getFail(error)).finally(() => {
      extractButtonSpinner(spinnerId)
      setIsShowRejectModal(false);
    })
  }


  const disabledOrEnable = (spinnerId) => {
    AlertService.alertConfirm(
      `Are you sure ?`,
      "",
      "Yes",
      "No"
    ).then(() => {
      setButtonSpinner(spinnerId);
      const data = {
        id: organizationData.id,
        updaterUserId: null,
        status: !organizationData.isDisabled
      }
      ApiService.disabledOrEnableOrganizationStatus(data).then(response => {
        AlertService.alert(SUCCESS_KEY, "Data saved");
        setOrganizationData((values) => ({
          ...values,
          isDisabled: !organizationData.isDisabled
        }))
      }).catch(error => getFail(error)).finally(() => {
        extractButtonSpinner(spinnerId)
      })
    })
  }

  const onPhoneNumberChange = (value, obj, fieldName) => {
    setOrganizationData((values) => ({
      ...values,
      [obj]: {
        ...values[obj],
        [fieldName]: value
      }
    }));
  }

  const toggleCustom = (key) => {
    setCustomIconActiveTab(key);
    localStorage.setItem("activeTab", key);
  }

  const getData = () => {
    if (!customActiveTab) { return null; }
    switch (customActiveTab) {
      case "1":
        return organizationData.levelOne;
      case "2":
        return organizationData.levelTwo;
      case "3":
        return organizationData.levelThree;
      default:
        break;
    }
  }

  const updateForm = (event) => {
    event && event.preventDefault();
    setButtonSpinner(buttonSpinnerId);
    (
      +customActiveTab === 1 ?
        ApiService.updateOrganizationDetailOneLevel(getData()) :
        +customActiveTab === 2 ?
          ApiService.updateOrganizationDetailTwoLevel(getData()) :
          +customActiveTab === 3 ?
            ApiService.updateOrganizationBankAccountAsAdmin(getData()) : () => { }
    ).then(response => {
      AlertService.alert("success", "Data saved");
      organizationId && getOrganizationById(organizationId);
      getRoutingTypesLibrary();
    }).catch(error => getFail(error)).finally(() => {
      setIsForm(false);
      extractButtonSpinner(buttonSpinnerId);
    })
  }

  const onDisabledEdirtButton = (data) => {
    if (!data) { return true; }
    if ((data.levelOne && +customActiveTab === 1) || (data.levelTwo && +customActiveTab === 2) || (data.levelThree && +customActiveTab === 3)) {
      return false;
    } else {
      return true;
    }
  }

  const setButtonSpinner = useCallback(spinner => {
    dispatch(addButtonSpinner(spinner));
  }, []);

  const extractButtonSpinner = useCallback(spinner => {
    dispatch(removeButtonSpinner(spinner));
  }, []);

  const setRightSectionSpinner = useCallback(spinner => {
    dispatch(addRightSectionSpinner(spinner));
  }, []);

  const extractRightSectionSpinner = useCallback(spinner => {
    dispatch(removeRightSectionSpinner(spinner));
  }, []);

  const getFail = (error) => {
    error && AlertService.alert((AlertService.checkMessageType(error.respcode) || ERROR_KEY), error);
  }

  return (
    <>
      <div className={`zoom-image-modal ${!zoomImagePath ? "d-none" : ""}`}>
        <img
          src={zoomImagePath ? zoomImagePath : ""}
          ref={wrapperRef}
        />
        <i className='bx bx-x close-icon'></i>
      </div>
      <HtmlHead title={title} description={description} />
      <div className='page-content position-relative min-h-100vh'>
        <RightSectionSpinner spinner={rightSectionSpinners} />
        <div className="container-fluid">
          {
            organizationData ?
              <div>
                <UncontrolledAlert color={organizationData.isApproved ? "success" : "danger"} role="alert">
                  {
                    organizationData.isApproved ?
                      "Current organization has received approval from the Cryllex administration."
                      :
                      "Current organization has not been approved by the Cryllex administration."
                  }
                </UncontrolledAlert>

                {
                  organizationData.isDisabled ?
                    <UncontrolledAlert color="danger" role="alert">
                      Current organization has been disabled by the Cryllex administration.
                    </UncontrolledAlert>
                    : null
                }
              </div>
              : null
          }


          <Breadcrumbs
            title="Cryllex"
            breadcrumbItem="Merchant KYC"
            isShowGoBackButton={true}
            goBack={() => {
              localStorage.removeItem("activeTab");
              window.history.back();
            }}
          />
          <Row>
            <Col lg={12}>
              <Card className='mb-5'>
                <CardBody>
                  {
                    organizationData ?
                      <>
                        <Nav tabs className="nav-tabs-custom nav-justified">
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={`${customActiveTab === "1" ? "active" : ""}`}
                              disabled={buttonSpinners.length ? true : false}
                              onClick={() => {
                                toggleCustom("1");
                                setIsForm(false);
                              }}
                            >
                              <span style={{ fontSize: "14px" }}>Level one</span>
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={`${customActiveTab === "2" ? "active" : ""}`}
                              disabled={buttonSpinners.length ? true : false}
                              onClick={() => {
                                toggleCustom("2");
                                setIsForm(false);
                              }}
                            >
                              <span style={{ fontSize: "14px" }}>Level two</span>
                            </NavLink>
                          </NavItem>
                          {
                            organizationData.levelThree || organizationData.significantControllers ?

                              <NavItem>
                                <NavLink
                                  style={{ cursor: "pointer" }}
                                  className={`${customActiveTab === "3" ? "active" : ""}`}
                                  disabled={buttonSpinners.length ? true : false}
                                  onClick={() => {
                                    toggleCustom("3");
                                    setIsForm(false);
                                  }}
                                >

                                  <span style={{ fontSize: "14px" }}>
                                    {
                                      organizationData.classificationType === 2 ? "Bank Account" : " Level three"
                                    }
                                  </span>
                                </NavLink>
                              </NavItem>
                              : null
                          }
                        </Nav>
                        <TabContent activeTab={customActiveTab} className="p-3 text-muted">
                          <TabPane tabId="1">
                            {
                              organizationData.levelOne ?
                                <Row>
                                  {
                                    isForm ?
                                      <LevelOneRequirementsForm
                                        data={organizationData}
                                        onChange={onChange}
                                        onSwitcherChange={onSwitcherChange}
                                        uploadFile={uploadFile}
                                        onPhoneNumberChange={onPhoneNumberChange}
                                        setZoomImagePath={setZoomImagePath}
                                        deleteDocument={deleteDocument}
                                        isDisabledFields={isDisabledFields}
                                        confirmProof={confirmProof}
                                        confirmLoaderId={confirmLoaderId}
                                      />
                                      : <LevelOneRequirements
                                        data={organizationData}
                                        setZoomImagePath={setZoomImagePath}
                                      />
                                  }
                                </Row>
                                : <NoData />
                            }
                          </TabPane>
                          <TabPane tabId="2">
                            {
                              organizationData.levelTwo ?
                                <Row>
                                  {
                                    isForm ?
                                      <LevelTwoRequirementsForm
                                        data={organizationData}
                                        onChange={onChange}
                                        uploadFile={uploadFile}
                                        bulkUploadFile={bulkUploadFile}
                                        setZoomImagePath={setZoomImagePath}
                                        onSelectOptionChange={onSelectOptionChange}
                                        deleteDocument={deleteDocument}
                                        countries={countries}
                                        confirmProof={confirmProof}
                                        confirmLoaderId={confirmLoaderId}
                                      />
                                      : <LevelTwoRequirements
                                        data={organizationData}
                                        setZoomImagePath={setZoomImagePath}
                                      />

                                  }
                                </Row> : <NoData />
                            }
                          </TabPane>
                          <TabPane tabId="3">
                            {
                              (organizationData.significantControllers && organizationData.significantControllers.length) || organizationData.levelThree ?

                                <div>
                                  {
                                    organizationData.significantControllers && organizationData.significantControllers.length && !isForm ?
                                      <div>
                                        <h5 className='bold my-3'>Significant controllers</h5>
                                        <Table striped bordered hover responsive>
                                          <thead>
                                            <tr className='cursor-default'>
                                              <th className="text-nowrap">Full name</th>
                                              <th className="text-nowrap">Email</th>
                                              <th className="text-nowrap">Phone Number</th>
                                              <th className="text-nowrap">Type</th>
                                              <th className="text-nowrap">Percentage</th>
                                              <th className={`text-nowrap ${windowSize?.width > 991 ? "sticky-actions-column" : ""}`}>Action</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {
                                              organizationData.significantControllers.map((item, index) => {
                                                return <tr key={index} className='cursor-default'>
                                                  <td className='fw-500'>{item.fullName}</td>
                                                  <td className='fw-500'>{item.email}</td>
                                                  <td className='fw-500'>{MainService.formatPhoneNumber(item.phoneNumber)}</td>
                                                  <td className='fw-500'>{item.typeName}</td>
                                                  <td className='fw-500'>{item.percentage}%</td>
                                                  <td className={`${windowSize?.width > 991 ? "sticky-actions-column" : ""}`}>
                                                    <div className="d-flex justify-content-center">
                                                      <OverlayTriggerComponent text="Edit">
                                                        <Link
                                                          to={`/${language}/significant-controllers-form/${item.id}`}
                                                          className='shadow-sm me-2 text-nowrap btn btn-primary'
                                                        >
                                                          <i className="bx bx-edit table-icon" />
                                                        </Link>
                                                      </OverlayTriggerComponent>
                                                    </div>
                                                  </td>
                                                </tr>
                                              })
                                            }
                                          </tbody>
                                        </Table>
                                        {
                                          organizationData.levelThree ?
                                            <hr />
                                            : null
                                        }
                                      </div>
                                      : null
                                  }
                                  {
                                    organizationData.levelThree ?
                                      <Row>
                                        {
                                          isForm ?
                                            <LevelThreeRequirementsForm
                                              data={organizationData}
                                              onChange={onChange}
                                              onSelectOptionChange={onSelectOptionChange}
                                              isDisabledFields={isDisabledFields}
                                              onSwitcherChange={onStatusSwitcherChange}
                                              currencies={currencies}
                                              payoutMethods={payoutMethods}
                                              holderTypes={holderTypes}
                                              banks={banks}
                                              onBankSelectOptionChange={onBankSelectOptionChange}
                                              selectedBankAccount={selectedBankAccount}
                                              validationData={validationData}
                                              isInvalid={isInvalid}
                                              _routingTypes={_routingTypes}
                                            />
                                            : <div>
                                              {
                                                organizationData.classificationType === 2 ? null :
                                                  <h5 className='bold my-3'>Bank account</h5>
                                              }
                                              <LevelThreeRequirements
                                                data={organizationData}
                                                setZoomImagePath={setZoomImagePath}
                                                countries={countries}
                                                currencies={currencies}
                                                payoutMethods={payoutMethods}
                                              />
                                            </div>
                                        }
                                      </Row>
                                      : null
                                  }
                                </div>
                                : <NoData />
                            }
                          </TabPane>
                        </TabContent>
                      </>
                      : <NoData />
                  }
                  <hr />
                  <div className='my-2 d-flex justify-content-end flex-wrap'>
                    <div className='d-flex mt-3'>
                      {
                        kycLevels && kycLevels.length ?
                          <Dropdown drop='up' disabled={isDisabledFields}>
                            <Dropdown.Toggle tag="button" className="btn btn-warning">
                              {
                                kycLevels.find(level => level.key === organizationData?.kycLevel) ?
                                  <div className='d-flex'>
                                    {kycLevels.map((level, idx) => {
                                      if (level.key === organizationData?.kycLevel) {
                                        return <div key={idx}>{level.value}</div>
                                      }
                                    })}
                                    <i className="mdi mdi-chevron-up ms-2" />
                                  </div>
                                  : <div className='d-flex'>Update KYC Level <i className="mdi mdi-chevron-down ms-2" /></div>
                              }
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              {
                                kycLevels.map((level, idx) => {
                                  return <Dropdown.Item
                                    key={idx}
                                    onClick={() => {
                                      if (organizationData?.kycLevel === level.key) {
                                        return false;
                                      }
                                      onChangeKycLevel(level.key, "kycLevel")
                                    }}
                                  >
                                    {level.value}
                                  </Dropdown.Item>
                                })
                              }
                            </Dropdown.Menu>
                          </Dropdown>
                          : null
                      }
                      {
                        isForm ?
                          <div className='d-flex'>
                            <Button
                              color="primary"
                              className='mx-2 px-4'
                              outline
                              disabled={isDisabledFields}
                              onClick={() => {
                                setIsForm(false);
                                setOrganizationData(_organizationData)
                              }}
                            >
                              Cancel
                            </Button>
                            <ActionButton
                              type="button"
                              name="Submit"
                              className="btn btn-primary btn-block px-4"
                              spinnerId={buttonSpinnerId}
                              disabled={isDisabledFields || !isFormValid()}
                              onClick={(event) => updateForm(event)}
                            />
                          </div> :
                          <Auxiliary>

                            <ActionButton
                              spinnerId={`accept_${buttonSpinnerId}`}
                              color="success"
                              className='ms-2 px-4'
                              disabled={organizationData?.kycLevel !== 3 || (organizationData && !organizationData.isApproved && !organizationData.isPending ? false : true)}
                              onClick={() => accept(`accept_${buttonSpinnerId}`)}
                            >
                              Accept
                            </ActionButton>

                            <Button
                              color="danger"
                              className='ms-2 px-4'
                              disabled={organizationData?.kycLevel !== 3 || (organizationData && organizationData.isRejected)}
                              onClick={() => setIsShowRejectModal(true)}
                            >
                              Reject
                            </Button>

                            <ActionButton
                              spinnerId={`disabled_${buttonSpinnerId}`}
                              color={organizationData?.isDisabled ? "info" : "secondary"}
                              className='ms-2 px-4'
                              disabled={organizationData?.kycLevel !== 3}
                              onClick={() => disabledOrEnable(`disabled_${buttonSpinnerId}`)}
                            >
                              {
                                organizationData?.isDisabled ? "Enable" : "Disable"
                              }
                            </ActionButton>

                            <Button color="primary" className='ms-2 px-4'
                              onClick={() => {
                                setIsForm(true);
                                scrollTop();
                              }}
                              disabled={onDisabledEdirtButton(organizationData)}
                            >
                              Edit
                            </Button>
                          </Auxiliary>
                      }
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>



        <Modal
          isOpen={isShowRejectModal}
          size="lg"
          role="dialog"
          className="exampleModal"
          tabIndex="-1"
          toggle={() => {
            setIsShowRejectModal(!isShowRejectModal)
          }}
        >
          <div className="modal-content">
            <ModalHeader
              toggle={() => {
                setIsShowRejectModal(!isShowRejectModal)
              }}
            >
              Reject
            </ModalHeader>
            <ModalBody>
              <form>
                <Label htmlFor='rejectMessage'>Rejection message</Label>
                <Input
                  id="rejectMessage"
                  type="textarea"
                  value={rejectMessage}
                  rows={4}
                  autoFocus
                  style={{ resize: "none" }}
                  placeholder='Please enter your rejection message'
                  className={`form-control ${isInvalidSubmit && !rejectMessage.trim().length ? "error-border" : ""}`}
                  onChange={(event) => _onChange(event, setRejectMessage, fieldLengths.length_2000)}
                />
              </form>
            </ModalBody>
            <ModalFooter>
              <div className='d-flex justify-content-end gap-2'>
                <Button
                  color="primary"
                  className='px-4'
                  outline
                  disabled={isDisabledFields}
                  onClick={() => {
                    setIsShowRejectModal(false);
                    setRejectMessage("");
                  }}
                >
                  Cancel
                </Button>
                <ActionButton
                  spinnerId={`reject_${buttonSpinnerId}`}
                  color="primary"
                  className='px-4'
                  onClick={() => reject(`reject_${buttonSpinnerId}`)}
                >
                  Save
                </ActionButton>
              </div>
            </ModalFooter>
          </div>
        </Modal>
      </div>
    </>
  )
}

export default OrganizationKYC